<div class="question-view__error-container fs__sm">
  @if (question.type !== questionType.Carousel && questionCtrl.invalid && questionCtrl.touched && questionCtrl.errors) {
    @if (questionCtrl.errors.required) {
      <span>{{ 'error.required' | translate }}</span>
    }
    @if (questionCtrl.errors.requiredOtherText) {
      <span>{{ 'error.requiredOtherText' | translate }}</span>
    }
    @if (questionCtrl.errors.email) {
      <span>{{ 'error.email' | translate }}</span>
    }
    @if (questionCtrl.errors.minlength) {
      <span>
        {{ 'error.minlength' | translate: { length: questionCtrl.errors.minlength.requiredLength } }}
      </span>
    }
    @if (questionCtrl.errors.maxlength) {
      <span>
        {{ 'error.maxlength' | translate: { length: questionCtrl.errors.maxlength.requiredLength } }}
      </span>
    }
    @if (questionCtrl.errors.min) {
      <span>
        {{ 'error.min' | translate: { min: questionCtrl.errors.min.required } }}
      </span>
    }
    @if (questionCtrl.errors.max) {
      <span>
        {{ 'error.max' | translate: { max: questionCtrl.errors.max.required } }}
      </span>
    }
    @if (questionCtrl.errors.minAreas) {
      <span>
        {{ 'error.minAreas' | translate: { min: questionCtrl.errors.minAreas } }}
      </span>
    }
    @if (questionCtrl.errors.maxAreas) {
      <span>
        {{ 'error.maxAreas' | translate: { max: questionCtrl.errors.maxAreas } }}
      </span>
    }
    @if (questionCtrl.errors.minFiles) {
      <span>
        {{ 'error.minFiles' | translate: { min: questionCtrl.errors.minFiles } }}
      </span>
    }
    @if (questionCtrl.errors.maxFiles) {
      <span>
        {{ 'error.maxFiles' | translate: { max: questionCtrl.errors.maxFiles } }}
      </span>
    }
  }

  @if (question.type === questionType.Carousel && questionCtrl.invalid && questionCtrl.touched) {
    <span>{{ 'error.required' | translate }}</span>
  }
</div>
